/**
 * Judge.me Revamp Widget Style Override
 * Forces theme-matching styles onto the Judge.me v3 revamp widget.
 * Revamp uses jm-* classes (not legacy jdgm-* classes).
 */
(function () {
  'use strict';

  function applyStyles() {
    var widget = document.getElementById('judgeme_product_reviews');
    if (!widget || !widget.children.length) return;

    /* === WRITE A REVIEW BUTTON → primary button style === */
    widget.querySelectorAll('.jm-action-buttons__button, [data-testid="write-review-button"]').forEach(function (btn) {
      btn.style.setProperty('background-color', '#000000', 'important');
      btn.style.setProperty('color', '#ffffff', 'important');
      btn.style.setProperty('border', '1px solid #000000', 'important');
      btn.style.setProperty('border-radius', '0', 'important');
      btn.style.setProperty('font-family', 'Inter, sans-serif', 'important');
      btn.style.setProperty('text-transform', 'uppercase', 'important');
      btn.style.setProperty('padding', '16px 24px', 'important');
      btn.style.setProperty('font-size', '1rem', 'important');
      btn.style.setProperty('text-decoration', 'none', 'important');
      btn.style.setProperty('cursor', 'pointer', 'important');
      btn.style.setProperty('letter-spacing', 'normal', 'important');
      btn.style.setProperty('line-height', '1', 'important');
    });

    /* === WIDGET TITLE → Poppins h3 style === */
    widget.querySelectorAll('.jm-review-widget-header__title').forEach(function (el) {
      el.style.setProperty('font-family', '"Poppins", sans-serif', 'important');
      el.style.setProperty('font-size', '1.5rem', 'important');
      el.style.setProperty('font-weight', '400', 'important');
      el.style.setProperty('line-height', '1.15', 'important');
      el.style.setProperty('text-transform', 'uppercase', 'important');
      el.style.setProperty('color', '#000', 'important');
      el.style.setProperty('letter-spacing', '0.04em', 'important');
    });

    /* === GALLERY → left-align thumbnails === */
    widget.querySelectorAll('.jm-media-grid__container').forEach(function (el) {
      el.style.setProperty('justify-content', 'flex-start', 'important');
      el.style.setProperty('--grid-justify-content', 'flex-start', 'important');
    });
    widget.querySelectorAll('.jm-media-grid').forEach(function (el) {
      el.style.setProperty('--grid-justify-content', 'flex-start', 'important');
    });
    /* Align media preview section to far left */
    widget.querySelectorAll('.jm-media-preview').forEach(function (el) {
      el.style.setProperty('align-self', 'flex-start', 'important');
    });

    /* === REVIEW BODY TEXT → Inter font === */
    widget.querySelectorAll('.jm-review-body-wrapper').forEach(function (el) {
      el.style.setProperty('font-family', '"Inter", sans-serif', 'important');
    });
  }

  /* MutationObserver: catch dynamically rendered widget content */
  var widget = document.getElementById('judgeme_product_reviews');
  if (widget) {
    var observer = new MutationObserver(function () {
      if (widget.children.length > 0) {
        applyStyles();
      }
    });
    observer.observe(widget, { childList: true, subtree: true });
  }

  /* Delayed fallbacks */
  setTimeout(applyStyles, 2000);
  setTimeout(applyStyles, 5000);
  setTimeout(applyStyles, 10000);

  /* === VIDEO AUTOPLAY on viewport entry === */
  /* Horizon's DeferredMedia doesn't auto-trigger play when scrolled into view */
  if ('IntersectionObserver' in window) {
    var autoplayTargets = document.querySelectorAll('deferred-media[autoplay]');
    if (autoplayTargets.length) {
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.25 });
      autoplayTargets.forEach(function (el) { videoObserver.observe(el); });
    }
  }
})();
